import * as api from '@/api';
import { prepareSavedRoutes } from '@/utils/route-utils';
import eventBus from '@/utils/event-bus';

export async function getAllFavourites({dispatch}) {
    dispatch('getFavourites');
    dispatch('getFavouritesLists')
    dispatch('getHome');
    dispatch('getWork');
}

export async function getFavourites({commit}){
    try {
        const response = await api.favourites.getFavourites();
        if(response.data && response.data.length) {
            commit('setFavourites', response.data);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function getHome({commit}) {
    try {
        // const response = await api.favourites.getHome(getters.user.identityKey);
        const response = await api.favourites.getHome();
        if(response && response.data) {
            commit('setHome', response.data);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function getWork({commit}) {
    try {
        const response = await api.favourites.getWork();
        if(response && response.data) {
            commit('setWork', response.data);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function getFavouritesLists({commit}){
    try {
        const response = await api.favourites.getFavouritesLists();
        if(response.data) {
            commit('setFavouritesLists', response.data.lists);
        }
        if(response.data && response.data.computed && response.data.computed.types) { // TODO: missing in my geo response
            commit('setSavedFavouriteTypes', response.data.computed.types)
        }
    } catch (error) {
        console.error(error);
    }
}


export async function getSavedRoutes({commit, dispatch}){
    try {
        const response = await api.favourites.getSavedRoutes();
        if(!response.data || !response.data.routes || !response.data.routes.length) return false;
        const routes = prepareSavedRoutes(response.data.routes);
        commit('setSavedRoutes', routes);
        if(routes.length > 0) {
            dispatch('getRouteTrafficAlerts')
        }
    } catch (error) {
        console.error(error);
    }
}

export async function addFavourite({commit, dispatch}, data){
    try {
        const response = await api.favourites.addFavourite(data);
        if(response.data) {
            if(response.data.favorites) {
                // if a favourite is added to a list, the whole list is returned by the API
                commit('editFavouritesList', response.data)
            } else {
                commit('addFavourite', response.data);
            }
            dispatch('getAllFavourites');
            eventBus.$emit('toggleFavourite', data.objectId) // add star on pin
            eventBus.$emit('favouriteAdded', data.objectId) // to update star in pin drop
        }
    } catch (error) {
        console.error(error);
    }
}

export async function addFavouritesList({commit}, data){
    try {
        const response = await api.favourites.addFavouritesList(data);
        if(response.data && response.data.id) {
            commit('addFavouritesList', response.data);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function addSavedRoute({commit}, data){
    try {
        const response = await api.favourites.addSavedRoute(data);
        if(response.data) {
            const preparedRoutes = prepareSavedRoutes([response.data])
            commit('saveRoute', preparedRoutes[0])
            commit('setActiveRouteSaved', { id: preparedRoutes[0].id, mode: preparedRoutes[0].mode, note: response.data.note })
            if(data.trafficAlert) {
                const snapshotResponse = await api.favourites.addRouteSnapshot(response.data.id, data.trafficAlertDetails)
                if(snapshotResponse.data) {
                    const routeGis2Id = response.data.gis2Id
                    eventBus.$emit('showTrafficAlertPage', routeGis2Id)
                }
            }
        }
    } catch (error) {
        console.error(error);
    }
}

export async function editFavourite({commit}, data) {
    try {
        const response = await api.favourites.editFavourite(data);
        if(response.data && response.data.id) {
            commit('editFavourite', response.data);
            commit('updatePoiFavourites', response.data)
        }
    } catch (error) {
        console.error(error);
    }
}

export async function editFavouritesList({commit}, data) {
    try {
        const response = await api.favourites.editFavouritesList(data);
        if(response.data && response.data.id) {
            commit('editFavouritesList', response.data);
        }
    } catch (error) {
        console.error(error);
    } 
}

export async function editSavedRoute({commit}, data){
    try {
        const response = await api.favourites.editSavedRoute(data);
        if(response.data) {
            const preparedRoutes = prepareSavedRoutes([response.data])
            commit('editSavedRoute', preparedRoutes[0])
        }
    } catch (error) {
        console.error(error);
    }
}

export async function removeFavourite({commit}, {favouriteId, objectId}){
    try {
        await api.favourites.removeFavourite(favouriteId);
        commit('removeFavourite', favouriteId);
        if(favouriteId.includes('home')) commit('setHome', false)
        if(favouriteId.includes('work')) commit('setWork', false)
        eventBus.$emit('toggleFavourite', objectId) // remove star on pin
    } catch (error) {
        console.error(error);
    }
}

export async function removeFavouritesList({commit}, listId){
    try {
        const response = await api.favourites.removeFavouritesList(listId);
        if(response.data === '') {
            commit('removeFavouritesList', listId);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function removeSavedRoute({commit}, routeId){
    try {
        await api.favourites.removeSavedRoute(routeId);
        commit('removeSavedRoute', routeId);
        commit('setActiveRouteSaved', false)
    } catch (error) {
        console.error(error);
    }
}

export async function getRouteTrafficAlerts({ commit }) {
    try {
        const response = await api.vibs.getAllRouteTrafficAlerts()
        if(response && response.data.length) {
            commit('setRouteTrafficAlerts', response.data)
        }
    } catch (error) {
        console.error(error);
    }
}

export async function removeRouteTrafficAlert({commit}, id) {
    try {
        await api.vibs.removeRouteTrafficAlert(id);
        commit('removeRouteTrafficAlert', id);
    } catch (error) {
        console.error(error);
    }
}